<template>
  <div>
    <div class="component-title">
      <div class="component-title">
        <h1 class="">Employment Details</h1>
      </div>
    </div>

    <form id="form8" autocomplete="off" style="font-size: 20px" class="mt-10">
      <br />
      <br />
      <div class="row Introduce-yourself-container">

        <div v-for="newContent in temp" :key="newContent.id">

          <div class="row pt-10 employment-container">
            <div class="col-sm-6 col-md-6">
              <span>Employment Status</span>
              <select
                class="employment_category"
                id="employment_category[0]"
                required=""
              >
                <option selected="selected" value="">Select</option>
                <option value="Part time">Part time</option>
                <option value="Full time">Full time</option>
                <option value="Casual">Casual</option>
                <option value="Self Employed">Self Employed</option>
                <option value="Government Benefits">Government Benefits</option>
              </select>
            </div>
            <div class="col-sm-6 col-md-6">
              <span>Company Name</span>
              <input
                placeholder="Company name*"
                id="employer_name[0]"
                required=""
                type="text"
              />
            </div>
          </div>

          <div class="row pt-10">
            <div class="col-sm-12 col-md-12">
              <span>Company Address</span>
              <input
                type="text"
                class="companyAddress"
                id="companyAddress[0]"
                required=""
                autofocus=""
              />
            </div>
          </div>

          <p class="pt-10">
            Can't find your address?
            <span
              style="color: green; cursor: pointer"
              onclick="$(this).closest('.Introduce-yourself-container').find('.address-expand').toggleClass('none')"
              >Click here</span
            >
          </p>
          <div class="address-expand none" id="company[0]">
            <div id="hideOnGovernmentBenefit[0]">
              <div class="row">
                <div class="col-sm-6 col-md-6">
                  <span>Unit Number</span>
                  <input
                    type="text"
                    id="company_unit_number[0]"
                    class=""
                    autofocus=""
                  />
                </div>
                <div class="col-sm-6 col-md-6">
                  <span>Street Number</span>
                  <input
                    type="text"
                    id="company_street_number[0]"
                    class=""
                    required=""
                    autofocus=""
                  />
                </div>
              </div>

              <div class="row pt-10">
                <div class="col-sm-6 col-md-6">
                  <span>Street Name</span>
                  <input
                    type="text"
                    id="company_route[0]"
                    class=""
                    required=""
                    autofocus=""
                  />
                </div>
                <div class="col-sm-6 col-md-6">
                  <span>City/Suburb</span>
                  <input
                    type="text"
                    id="company_locality[0]"
                    class=""
                    required=""
                    autofocus=""
                  />
                </div>
              </div>

              <div class="row pt-10">
                <div class="col-sm-6 col-md-6">
                  <span>State</span>
                  <input
                    type="text"
                    id="company_administrative_area_level_1[0]"
                    class=""
                    required=""
                    autofocus=""
                  />
                </div>
                <div class="col-sm-6 col-md-6">
                  <span>Postcode</span>
                  <input
                    type="text"
                    id="company_postal_code[0]"
                    class=""
                    required=""
                    autofocus=""
                  />
                </div>
              </div>
            </div>

            <div id="displayOnGovernmentBenefit[0]">
              <div class="row pt-10">
                <div class="col-sm-6 col-md-6">
                  <span>Country</span>
                  <input
                    type="text"
                    id="company_country[0]"
                    class=""
                    required=""
                    autofocus=""
                  />
                </div>
                <div
                  class="col-sm-6 col-md-6 radio-container"
                  style="padding-top: 5px"
                >
                  <span style="white-space: nowrap"
                    >Are you Currently Employed by this Employer?</span
                  >
                  <input
                    class="form-check-input currentEmployment"
                    type="radio"
                    id="current_employment_yes[0]"
                    value="0"
                  />
                  <label class="form-check-label" for="current_employment_yes[0]"
                    >Yes</label
                  >
                  <input
                    class="form-check-input currentEmployment"
                    type="radio"
                    id="current_employment_no[0]"
                    value="1"
                  />
                  <label class="form-check-label" for="current_employment_no[0]"
                    >No</label
                  >
                </div>
              </div>

              <div class="row pt-10 mb-20">
                <div class="col-sm-6 col-md-6"></div>
                <div class="col-sm-6 col-md-6 radio-container none">
                  <span style="white-space: nowrap"
                    >How long have you been in this employment?</span
                  >
                  <div class="time_interval">
                    <div class="row">
                      <div class="col-md-6">
                        <input
                          type="date"
                          class="start_date"
                          max="2022-08-20"
                          id="start_date[0]"
                          placeholder="Start date"
                          required=""
                        />
                      </div>
                      <div class="col-md-6">
                        <input
                          type="date"
                          class="end_date none"
                          max="2022-08-20"
                          id="end_date[0]"
                          placeholder="End date"
                          required=""
                        />
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>

          <div class="clear"></div>

          <div v-if="newContent.id!=0" class="flx pointer change-employment-btn pt-10" style="width: max-content" @click="removeEmployment($event, newContent.id)">
            <div class="reduce-icon">-</div>
            <div>Remove Employment</div>
          </div>
          
        </div>

        
      </div>

      <div class="container pl-40 pr-40">
        <div
          class="flx pointer change-employment-btn pt-10 addEmploymentBtn"
          style="width: max-content" @click="addEmployment()"
        >
          <div class="add-icon">+</div>
          <span>Add Employment</span>
        </div>
        <input
          type="text"
          name="length_of_employment"
          id="length_of_employment"
          class="input-hidden"
        />
        <input
          type="text"
          name="date_validated"
          id="date_validated"
          class="input-hidden"
          value="0"
          style="height: 0"
        />
        <label
          id="date_validated-error"
          class="error"
          for="date_validated"
        ></label>
        <label
          id="length_of_employment-error"
          class="error"
          for="length_of_employment"
        ></label>
      </div>
    </form>

    <div class="flx loan-container mt-60">
      <a
        type="button"
        class="continue-btn continue-btn-small steps-btn"
        href="#"
        @click.prevent="onContinue('residential-details')"
        >BACK</a
      >
      <a
        type="button"
        class="continue-btn continue-btn-small continue-btn-small-right steps-btn"
        href="#"
        @click.prevent="onContinue('financial-capacity')"
        >CONTINUE</a
      >
    </div>
    <div class="mt-60 clear"></div>
  </div>
</template>

<script>
export default {
  props: ["onChangeStep"],
  data: ()=>{
    return {
      id: 0,
      temp: [{id: 0}],}
  },
  methods: {
    onContinue(step) {
      this.onChangeStep(step);
    },
    addEmployment(){
      var new_id = 0;
      do{++new_id;}while(this.temp.find(e => e.id === new_id));
      this.temp.push({
        id: new_id
      })
    },
    removeEmployment(event, id){
      var index = this.temp.map(object => object.id).indexOf(id);
      this.temp.splice(index,1);
    },
  },
};
</script>
